import {AxiosPromise} from "axios";
import API, {config} from "Connectors/_main";
import {GetCountiesResponse, GetVoivodeshipResponse} from "API/Region/Region.Models";

export function getVoivodeships(): AxiosPromise<GetVoivodeshipResponse> {
  return API.get(`region/provinces`, config());
}

export function getCountiesByVoivodeship(params: URLSearchParams): AxiosPromise<GetCountiesResponse> {
  return API.get(`region/counties`, config(params))
}



// WEBPACK FOOTER //
// ./src/API/Region/Region.Connectors.ts